
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"--tg-bg-color":"#484F67"},style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg","style":"--tg-bg-color:#484F67"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_42270_117523)"}},[_c('path',{attrs:{"d":"M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12z","fill":"var(--tg-bg-color)"}}),_c('path',{attrs:{"d":"M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12z","fill":"var(--tg-bg-color)"}}),_c('path',{attrs:{"d":"M5.394 11.735c3.49-1.552 5.816-2.575 6.98-3.07C15.7 7.253 16.39 7.008 16.84 7c.099-.002.32.023.464.142a.52.52 0 01.17.331c.016.095.036.312.02.481-.18 1.933-.96 6.623-1.356 8.787-.168.916-.498 1.224-.818 1.253-.695.066-1.223-.468-1.896-.92-1.054-.704-1.65-1.143-2.672-1.831-1.182-.796-.416-1.233.258-1.947.176-.187 3.24-3.031 3.298-3.29.008-.032.015-.152-.055-.215-.07-.064-.174-.042-.248-.025-.106.025-1.789 1.16-5.05 3.408-.477.335-.91.498-1.298.49-.427-.01-1.25-.248-1.86-.45-.75-.25-1.346-.38-1.294-.803.027-.22.324-.445.89-.676z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_42270_117523"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/lk/img/TG.svg